module.exports = __webpack_public_path__ + "static/img/4596783aed2218520097da885b23b8d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advant_disable_02.png
// module id = hoBA
// module chunks = 1